(()=>{
 function init(scope=document){scope.querySelectorAll('[data-rf-shades]').forEach(root=>{
  if(root.dataset.ready)return;root.dataset.ready='true';
  const data=JSON.parse(root.querySelector('[data-rf-shades-data]').textContent);
  if(!data.length)return;
  const buttons=[...root.querySelectorAll('[data-rf-shade]')];
  const image=root.querySelector('.rf-shades__image');
  const cache=new Map();let active=0,requested=0,revision=0;
  const normalize=index=>(index+data.length)%data.length;
  function loadImage(url){
   if(cache.has(url))return cache.get(url);
   const promise=new Promise((resolve,reject)=>{
    const candidate=new Image();candidate.decoding='async';
    candidate.onload=()=>{
     const decoded=typeof candidate.decode==='function'?candidate.decode():Promise.resolve();
     decoded.then(()=>resolve(candidate),reject);
    };
    candidate.onerror=()=>reject(new Error('Image de teinte indisponible'));
    candidate.src=url;
   }).catch(error=>{cache.delete(url);throw error;});
   cache.set(url,promise);return promise;
  }
  function preloadNext(){loadImage(data[normalize(active+1)].image).catch(()=>{});}
  function select(index){
   requested=normalize(index);const target=requested,item=data[target],ticket=++revision;
   if(target===active){root.setAttribute('aria-busy','false');return;}
   root.setAttribute('aria-busy','true');
   loadImage(item.image).then(candidate=>{
    if(ticket!==revision)return;
    // Keep the displayed shade intact until its replacement is loaded and decoded.
    // Image, copy and selected state are committed together before the next paint.
    image.removeAttribute('srcset');image.src=candidate.src;image.alt=item.alt;
    active=target;
    root.querySelector('[data-rf-shade-number]').textContent=String(active+1).padStart(2,'0')+' / '+String(data.length).padStart(2,'0');
    root.querySelector('[data-rf-shade-name]').textContent=item.name;
    root.querySelector('[data-rf-shade-description]').textContent=item.description;
    root.querySelector('[data-rf-shade-caption]').textContent=item.name;
    buttons.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===active)));
    root.setAttribute('aria-busy','false');preloadNext();
   }).catch(()=>{
    if(ticket!==revision)return;
    requested=active;root.setAttribute('aria-busy','false');
   });
  }
  buttons.forEach((b,i)=>{b.addEventListener('click',()=>select(i));b.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;e.preventDefault();const next=normalize(e.key==='Home'?0:e.key==='End'?data.length-1:requested+(e.key==='ArrowRight'?1:-1));select(next);buttons[next].focus();});});
  root.querySelector('[data-rf-shade-prev]').addEventListener('click',()=>select(requested-1));
  root.querySelector('[data-rf-shade-next]').addEventListener('click',()=>select(requested+1));
  preloadNext();
 });}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
 document.addEventListener('shopify:section:load',e=>init(e.target));
})();
